<template>
    <div class="alert alert-info" role="alert">
        <span class="alert-icon" aria-hidden="true" />
        <div class="alert-content">
            <a
                :href="linkUrl"
                class="ob1-link-arrow ob1-link-dark ob1-link-small"
            >{{ message }}</a>
        </div>
    </div>
</template>
<script>

export default {
    props: {
        linkUrl: {
            type: String,
            required: true
        },
        message: {
            type: String,
            required: true
        },
    },

}
</script>

<style scoped lang="scss">

.alert-wrapper .alert {
    display: inline-flex;
    padding: 0 22px 0 7px;
}

.alert .alert-icon {
    font-size: 24px;
}

.alert-wrapper .ob1-link-arrow {
    max-width: 100%;
}

</style>
